import { jsx } from '@emotion/react';

const Menu = (props) => {
  return jsx("ul", { role: props.role, "aria-label": props["aria-label"], "data-zds": true }, props.children);
};

export { Menu };
//# sourceMappingURL=Menu.es.js.map
